import { render, staticRenderFns } from "./PurchaseSummary.vue?vue&type=template&id=6b937429&scoped=true&"
import script from "./PurchaseSummary.vue?vue&type=script&lang=js&"
export * from "./PurchaseSummary.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSummary.vue?vue&type=style&index=0&id=6b937429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b937429",
  null
  
)

export default component.exports